import { render, staticRenderFns } from "./SendBundlePaymentModal.vue?vue&type=template&id=3b83b320&scoped=true"
import script from "./SendBundlePaymentModal.vue?vue&type=script&lang=js"
export * from "./SendBundlePaymentModal.vue?vue&type=script&lang=js"
import style0 from "./SendBundlePaymentModal.vue?vue&type=style&index=0&id=3b83b320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b83b320",
  null
  
)

export default component.exports